import React, { createContext, useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const token = localStorage.getItem("_uid");
  const [isAuth, setAuth] = useState(!!token);

  const handleDetectNoAuthorize = () => {
    axios.interceptors.response.use(
      (config) => config,
      (error) => {
        if (error.response.status === 401) {
          handleLogout();
          return Promise.reject(error);
        } else {
          return Promise.reject(error);
        }
      }
    );
  };

  // const checkToken = (token) => {
  //   if (token) {
  //     handleLogin();
  //   } else {
  //     handleLogout();
  //   }
  // };

  const handleLogout = () => {
    localStorage.clear();
    setAuth(false);
  };
  const handleLogin = () => {
    setAuth(true);
  };

  useEffect(() => {
    handleDetectNoAuthorize();
  }, []);

  // useEffect(() => {
  //   checkToken(token);
  // }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuth,
        handleLogout,
        handleLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
